import { paragraphSpec } from './nodes/paragraph-spec';
import { smallSpec } from './nodes/small-spec';
import { headingSpec, subheading3Spec, subheading4Spec, subheadingSpec } from './nodes/heading-spec';
import { calloutSpec } from './nodes/callout-spec';
import { codeBlockSpec } from './nodes/code-block-spec';
import { videoFileSpec } from './nodes/video-file-spec';
import { audioFileSpec } from './nodes/audio-file-spec';
import { imageSpec } from './nodes/image-spec';
import { videoSpec } from './nodes/video-spec';
import { buttonSpec } from './nodes/button-spec';
import { tableCellSpec, tableRowSpec, tableSpec } from './nodes/table-spec';
import { listItemSpec, nestedListItemSpec, orderedListSpec, orderedNestedListSpec, unorderedListSpec, unorderedNestedListSpec } from './nodes/list-spec';
import { hardBreakSpec } from './nodes/hard-break-spec';
import { templateSpec } from './nodes/template-spec';
import { mentionSpec } from './nodes/mention-spec';
import { aiPromptDataSpec } from './nodes/ai-prompt-data-spec';
import { htmlSpec } from './nodes/html-spec';
import { horizontalRuleSpec } from './nodes/horizontal-rule-spec';
import { ifElseStatementSpec } from './nodes/if-else-statement-spec';
import { messengerCardSpec } from './nodes/messenger-card-spec';
import { markerSpec } from './nodes/marker-spec';
import { placeholderSpec } from './nodes/placeholder-spec';
import { twitterFollowButtonSpec } from './nodes/twitter-follow-button-spec';
import { facebookLikeButtonSpec } from './nodes/facebook-like-button-spec';
import { socialSpec } from './nodes/social-spec';
import { spacerSpec } from './nodes/spacer-spec';
import { collapsibleSectionContentSpec, collapsibleSectionSpec, collapsibleSectionSummarySpec } from './nodes/collapsible-section-spec';
import { inlineImageSpec } from './nodes/inline-image-spec';
import { unsupportedElementSpec } from './nodes/unsupported-element-spec';
import { imageTextSpec } from './nodes/image-text-spec';
export let nodeSpecs = {
  doc: {
    content: '(block | list | table)+'
  },
  singleBlockDoc: {
    content: '(block | list | table)'
  },
  text: {
    group: 'inline'
  },
  paragraph: paragraphSpec,
  hardBreak: hardBreakSpec,
  template: templateSpec,
  mention: mentionSpec,
  aiPromptData: aiPromptDataSpec,
  html: htmlSpec,
  horizontalRule: horizontalRuleSpec,
  orderedList: orderedListSpec,
  unorderedList: unorderedListSpec,
  listItem: listItemSpec,
  heading: headingSpec,
  subheading: subheadingSpec,
  subheading3: subheading3Spec,
  subheading4: subheading4Spec,
  small: smallSpec,
  codeBlock: codeBlockSpec,
  ifElseStatement: ifElseStatementSpec,
  image: imageSpec,
  inlineImage: inlineImageSpec,
  videoFile: videoFileSpec,
  audioFile: audioFileSpec,
  video: videoSpec,
  button: buttonSpec,
  messengerCard: messengerCardSpec,
  marker: markerSpec,
  table: tableSpec,
  tableRow: tableRowSpec,
  tableCell: tableCellSpec,
  orderedNestedList: orderedNestedListSpec,
  unorderedNestedList: unorderedNestedListSpec,
  nestedListItem: nestedListItemSpec,
  placeholder: placeholderSpec,
  twitterFollowButton: twitterFollowButtonSpec,
  facebookLikeButton: facebookLikeButtonSpec,
  social: socialSpec,
  spacer: spacerSpec,
  callout: calloutSpec,
  collapsibleSection: collapsibleSectionSpec,
  collapsibleSectionSummary: collapsibleSectionSummarySpec,
  collapsibleSectionContent: collapsibleSectionContentSpec,
  unsupportedElement: unsupportedElementSpec,
  imageText: imageTextSpec
};